export const FETCH_PSYCHOLOGIST = 'FETCH_PSYCHOLOGIST';
export const CREATE_PSYCHOLOGIST = 'CREATE_PSYCHOLOGIST';
export const UPDATE_PSYCHOLOGIST = 'UPDATE_PSYCHOLOGIST';
export const FETCH_PSYCHOLOGIST_FEEDBACKS = 'FETCH_PSYCHOLOGIST_FEEDBACKS';
export const FETCH_PSYCHOLOGIST_NEWS = 'FETCH_PSYCHOLOGIST_NEWS';
export const CREATE_PSYCHOLOGIST_DIPLOMA = 'CREATE_PSYCHOLOGIST_DIPLOMA';
export const DELETE_PSYCHOLOGIST_DIPLOMA = 'DELETE_PSYCHOLOGIST_DIPLOMA';